import React from 'react'
import { Link,withRouter } from 'react-router-dom'
import Paper from 'material-ui/Paper'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'

import { inject,observer } from 'mobx-react'
import { withLayout } from '../../utils/hoc'
import Icon from 'material-ui/Icon'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog'
import T from 'i18n-react'
import { withCookies, Cookies } from 'react-cookie'


@inject('admin','adminui') @observer
class Login extends React.Component {
  render () {
    const admin = this.props.admin, adminui = this.props.adminui

    return (
      <div style={{width:'100vw',height:'100vh',animation:'bg-color 60s infinite',WebkitAnimation:'bg-color 60s infinite'}}>
      <Paper className="center-center admin-login-card">

       <TextField
        id="name"
        autoFocus
        label={T.translate("admin.login.name")}
        value={admin.loginname}
        onChange={e => admin.setLoginname(e.target.value)}
        onKeyPress={this.loginOnEnter}
       />

       <TextField
        id="password"
        type="password"
        label={T.translate("admin.login.password")}
        value={admin.password}
        onChange={e => admin.setPassword(e.target.value)}
        onKeyPress={this.loginOnEnter}
       />

       <Button color="secondary" fullWidth onClick={this.handleSubmit} style={{marginTop:15}}> {T.translate("admin.login.submit")} </Button>

      </Paper>
      </div>
    )
  }

  componentWillMount () {
    const { cookies } = this.props
    this.props.admin.logout(this.props.history,cookies)
  }

  handleSubmit = (e) => {
    const { cookies } = this.props
    e.preventDefault()
    this.props.admin.login(this.props.history,cookies)
  }

  loginOnEnter = (e) => {
    const { cookies } = this.props
    if (e.keyCode === 13 || e.which === 13) {
     this.props.admin.login(this.props.history,cookies)
    }
  }
}



export default withCookies(withLayout(withRouter(Login)))



// WEBPACK FOOTER //
// ./src/components/admin/login.js